module.exports = __webpack_public_path__ + "static/media/logo-mcafee.3fb92e71.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-mcafee.png
// module id = 386
// module chunks = 0